import FulfillmentProductDetailsPage from "./FulfillmentProductDetailsPage";
export default FulfillmentProductDetailsPage;
